// extracted by mini-css-extract-plugin
export default {"formDiv":"styles_formDiv__8XAKQ","inputText":"styles_inputText__Mtl5P","forgetLink":"styles_forgetLink__Qa53n"};